import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/login-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-c543d8f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "section1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "app_title" }, "PAYMENT STATUS PORTAL", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Reset Password", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-logo",
  style: {"padding":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Aboitiz logo",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("h6", null, "Power Plant Outage Reporting Tool")
], -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "You have successfully reset your password!", -1))
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Invalid reset password code!", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "The reset code you have may be expired or already used.", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, [
  /*#__PURE__*/_createTextVNode("You can try logging in "),
  /*#__PURE__*/_createElementVNode("a", { href: "/login" }, "here"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_16 = { class: "footer" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Power Plant Outage Reporting Tool", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(". All rights reserved.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _hoisted_4,
        _createVNode(_component_a_spin, { spinning: _ctx.loading }, {
          default: _withCtx(() => [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  (_ctx.isValidCode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("p", _hoisted_10, "We emailed your new password to " + _toDisplayString(_ctx.email), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14)),
                  _hoisted_15,
                  _createElementVNode("p", _hoisted_16, [
                    _createTextVNode("Copyright © " + _toDisplayString(_ctx.currentYear) + " ", 1),
                    _hoisted_17,
                    _hoisted_18
                  ])
                ]))
          ]),
          _: 1
        }, 8, ["spinning"])
      ])
    ])
  ]))
}